import { render, staticRenderFns } from "./ExploitableCvesPortlet.vue?vue&type=template&id=189710a9&scoped=true"
import script from "./ExploitableCvesPortlet.vue?vue&type=script&lang=js"
export * from "./ExploitableCvesPortlet.vue?vue&type=script&lang=js"
import style0 from "./ExploitableCvesPortlet.vue?vue&type=style&index=0&id=189710a9&prod&lang=css"
import style1 from "./ExploitableCvesPortlet.vue?vue&type=style&index=1&id=189710a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189710a9",
  null
  
)

export default component.exports